var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12817)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13556_12817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6821 22.7825C38.1924 19.3765 35.5973 17.5451 32.0515 16.3231L33.202 11.7081L30.394 11.0094L29.2728 15.5025C28.535 15.3173 27.7778 15.145 27.0221 14.9728L28.1515 10.4504L25.3435 9.75L24.193 14.3634C23.582 14.2236 22.9808 14.0871 22.399 13.9409L22.4023 13.9262L18.5283 12.9594L17.7808 15.9591C17.7808 15.9591 19.8656 16.4369 19.8218 16.4661C20.9593 16.7505 21.164 17.5029 21.1299 18.1009L19.8201 23.3577C19.8981 23.3773 19.9989 23.4065 20.1126 23.4504L19.8153 23.3773L17.979 30.7418C17.8393 31.0863 17.4866 31.6046 16.6904 31.408C16.7196 31.4486 14.6494 30.8994 14.6494 30.8994L13.2551 34.1136L16.9114 35.0253C17.5906 35.1959 18.2569 35.3746 18.9118 35.542L17.7499 40.209L20.5563 40.9078L21.7068 36.2928C22.4738 36.4991 23.218 36.6909 23.946 36.8729L22.7988 41.4684L25.6068 42.1671L26.7686 37.5099C31.5591 38.4166 35.1601 38.051 36.6763 33.7188C37.8983 30.2315 36.6161 28.2181 34.0958 26.9068C35.932 26.4843 37.3133 25.2769 37.6821 22.7825ZM31.2634 31.7818C30.3973 35.2706 24.5229 33.384 22.6184 32.9111L24.1621 26.728C26.0666 27.2041 32.1718 28.145 31.2634 31.7818ZM32.1328 22.7321C31.3414 25.9058 26.4534 24.2921 24.869 23.8973L26.2665 18.291C27.8509 18.6859 32.9583 19.422 32.1328 22.7321Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13556_12817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.c280739357068012043689a40f0c6260.svg";
export { ForwardRef as ReactComponent };